import { render, staticRenderFns } from "./DiagnosticPage.vue?vue&type=template&id=a4062e5a&"
import script from "./DiagnosticPage.vue?vue&type=script&lang=js&"
export * from "./DiagnosticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports